
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"url(#pattern0_16852_1590)","d":"M0 0h100v100H0z"}}),_c('defs',[_c('pattern',{attrs:{"id":"pattern0_16852_1590","patternContentUnits":"objectBoundingBox","width":"1","height":"1"}},[_c('use',{attrs:{"xlink:href":"#image0_16852_1590","transform":"scale(.01)"}})]),_c('image',{attrs:{"id":"image0_16852_1590","width":"100","height":"100","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAC4klEQVR4nO3dO2sVQRjG8SFi4d1WEMUutcRGwURFowheinwIsdBOQU2vdvoN1DQBwU4bW22M16BfwWsRo6LVXwb2kBMhxJPsO+87e54fnH6eeZLZ3cmeSUoiIiIiEhiwBZgEpobsM5mzp0iAo8BXhtcX4EiKANgOfPOekQDyHGyLUMh575kI5GyEQs55z0IgZ7z70JIVbcnK8gWtubANq8/ARIoE2AwcD3AbOlX4kzNv8p5/ERERETEBHAKeA3+8HwICyXPxDDhYuoxR4Kd3+sDy3IyWLOSud+IK3ClZyEPvtBV4WLKQq95pK3ClZCFbgVfeiQOby3NUrJC+v6FfBu4Ds/ow28zFpbzRWrQMEREREbEAbABOAreBGd3y0rvtn2nmJL9eOlKqjAPAvPeTVwXeAWPWZUwAv7yTViTP1bhVGTub949kMJ+AHRaFTA84EFly3aIQbSau3ZxFIT/WMaBht2hRiKyDCglGhQSjQoJRIcGokGC6WMg88LjW3YIuFbIAnPrnm1rTte2pdamQCyuMZx/wiEp0qZBdq4zrGPCB4DpTSPq/sW1s3odaJKihKqQH2A3cI6DUtpqCEHAZG+pCIi5jqW21BiHIMtZOC8uDVR0E52WsrRz9gaoPguMy1maOXhgXyUDzUPmm6hwlB28aZCnPHuA3hVgEcJEMAU+rzVFq4OZBlmdSIYNKdmXsLXnogUUAF8mALupBCkG3vXF+Q9CDYTvS+ovQ1kmb0tqL0OaihbS2MrT9biVVuDy19YO1WtiwQQi2PHW6EPSSQ7hCLq4wHr0G5OQ7cLqvCL0o5/wb0vMeeFLrof9duoZ0ggoJRoUEo0KCUSHBqJAhKCTstkQFFiwKeemdqmIvLAq54Z2qYtesjmfKRw3JYD6aHM/UlDJe25ctneW5OmxSRl8pY8Bb76QVeA3sNy2jr5QR4ARwC3igQzDpHYKZ5+Jm888myxyCKSIiIiIiIiIiIpL9BRIlpLYhHcehAAAAAElFTkSuQmCC"}})])])
          )
        }
      }
    